import React, { Component } from "react";
import { IProps, IState } from "./interfaces";
import { isMobile } from "../../../common/parameters";

class Draggable extends Component<IProps, IState> {
    startedAt?: number;
    timer?: number
    touchStarted: boolean = false;
    state: IState = {
        mouseX: null,
        mouseY: null,
        startX: null,
        startY: null,
        dragging: false,
    };
    componentDidMount() {
        document.ontouchmove = function () {};
    }

    mouseMove = (e: MouseEvent) => this.handleMove(e.clientX, e.clientY);
    mouseUp = (e?: MouseEvent | TouchEvent) => {
        const { onStop, onClick } = this.props;
        window.removeEventListener("mousemove", this.mouseMove);
        window.removeEventListener("touchmove", this.touchMove);
        window.removeEventListener("mouseup", this.mouseUp);
        document.ontouchmove = function () {};
        window.removeEventListener("touchend", this.mouseUp);
        setTimeout(() => {
            this.touchStarted = false;
        });
        if (e) {
            e.preventDefault();
        }
        if (this.state.dragging) {
            if (onStop) onStop(e as unknown as MouseEvent | TouchEvent);
        } else {
            if (onClick) onClick(e as unknown as MouseEvent | TouchEvent);
        }
        this.setState({ dragging: false });
    };
    componentWillUnmount() {
        clearTimeout(this.timer);
    }

    touchMove = (e: TouchEvent) => {
        e.preventDefault();
        let clientX = e.changedTouches[0].clientX;
        let clientY = e.changedTouches[0].clientY;
        this.handleMove(clientX, clientY);
    };

    handleMove(clientX: number, clientY: number) {
        const { mouseX, mouseY, startX, startY, dragging } = this.state;
        let { scale = 1, onDrag, onDragStart, noBoundry } = this.props;
        if (clientX < 0 || clientY < 0 || clientX > window.innerWidth || clientY > window.innerHeight) {
            this.mouseUp();
            return;
        }
        let xPos = startX! - (mouseX! - clientX) / scale;
        let yPos = startY! - (mouseY! - clientY) / scale;
        if (!noBoundry) {
            xPos = Math.max(xPos, 0);
            yPos = Math.max(yPos, 0);
        }

        if (!dragging) {
            let a = Math.abs(startX! - xPos);
            let b = Math.abs(startY! - yPos);
            let distance = Math.sqrt(a ** 2 + b ** 2);
            if (distance > 6 || this.startedAt! + 300 < new Date().getTime()) {
                if (onDragStart) onDragStart();
                this.setState({
                    dragging: true,
                });
            }
        }
        if (onDrag) onDrag(xPos, yPos);
    }

    mouseDown = (e: React.MouseEvent) => {
        const { disabled, position, onStart } = this.props;
        if (isMobile) return;
        if (disabled || this.touchStarted) return;
        if (window.getSelection && window.getSelection()) {
            window.getSelection()!.removeAllRanges();
        }
        e.stopPropagation();
        this.setState({
            mouseX: e.clientX,
            mouseY: e.clientY,
            startX: position.x,
            startY: position.y,
        });
        window.addEventListener("mousemove", this.mouseMove);
        window.addEventListener("mouseup", this.mouseUp);

        this.startedAt = new Date().getTime();
        if (onStart) onStart(e as unknown as MouseEvent);
    };

    touchStart = (e: React.TouchEvent) => {
        const { disabled, position, onStart } = this.props;
        if (disabled) return;
        if (window.getSelection && window.getSelection()) {
            window.getSelection()!.removeAllRanges();
        }
        e.stopPropagation();
        this.setState({
            mouseX: e.changedTouches[0].clientX,
            mouseY: e.changedTouches[0].clientY,
            startX: position.x,
            startY: position.y,
        });
        this.touchStarted = true;
        window.addEventListener("touchmove", this.touchMove);
        document.ontouchmove = function (e) {
            e.preventDefault();
        };
        window.addEventListener("touchend", this.mouseUp);
        this.startedAt = new Date().getTime();
        if (onStart) onStart(e as unknown as TouchEvent);
    };

    mouseEnter = () => {
        if (this.props.onMouseEnter) {
            this.props.onMouseEnter();
        }
    }

    render() {
        const { props } = this;
        const { zIndex, position, transition, bottom } = props;
        return (
            <div
                style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    bottom,
                    zIndex: zIndex || 1,
                    transform: `translate(${position.x}px, ${position.y}px)`,
                    transition: (transition ? "0.32" : "0") + "s",
                    touchAction: "none",
                    willChange: "transform",
                }}
                onMouseDown={this.mouseDown}
                onTouchStart={this.touchStart}
                onMouseEnter={this.mouseEnter}
            >
                {props.children}
            </div>
        );
    }
}

export default Draggable;
